/* eslint-disable vue/no-reserved-component-names */
import Vue from 'vue'
import AppInput from '../components/shared/AppInput.vue'
import AppDatePicker from '../components/shared/AppDatePicker.vue'
import AppInputCheck from '../components/shared/AppInputCheck.vue'
import Input from '../components/shared/Input.vue'
import AppSelect from '../components/shared/AppSelect.vue'

Vue.component('AppInput', AppInput)
Vue.component('AppDatePicker', AppDatePicker)
Vue.component('AppInputCheck', AppInputCheck)
Vue.component('Input', Input)
Vue.component('AppSelect', AppSelect)
